// extracted by mini-css-extract-plugin
export default {"ant-menu-submenu":"style_ant-menu-submenu__fjIoT","languageName":"style_languageName__C6sgV","span":"style_span__3u36J"};